/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_revcomp_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Tick RNA output and the result is written with U in place of T. U in the input is treated as equivalent to T.`)
};

const es_revcomp_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Marca la salida en ARN y el resultado se escribe con U en lugar de T. La U en la entrada se trata como equivalente a T.`)
};

const de_revcomp_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Aktivieren Sie RNA-Ausgabe, und das Ergebnis wird mit U anstelle von T geschrieben. U in der Eingabe wird als gleichwertig mit T behandelt.`)
};

const nl_revcomp_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Vink RNA-uitvoer aan en het resultaat wordt geschreven met U in plaats van T. U in de invoer wordt behandeld als gelijkwaardig aan T.`)
};

const fr_revcomp_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Cochez sortie ARN et le résultat est écrit avec U à la place de T. U dans l'entrée est traité comme équivalent à T.`)
};

const it_revcomp_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Seleziona output RNA e il risultato viene scritto con U al posto di T. La U nell'input viene trattata come equivalente a T.`)
};

const pt_br2_revcomp_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Marque saída em RNA e o resultado é escrito com U no lugar de T. O U na entrada é tratado como equivalente a T.`)
};

const pt_revcomp_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Assinale a saída em ARN e o resultado é escrito com U em vez de T. O U na entrada é tratado como equivalente a T.`)
};

const ja_revcomp_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。RNA出力にチェックを入れると、Tの代わりにUで結果が出力されます。入力中のUはTと同等に扱われます。`)
};

const zh_revcomp_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持。勾选 RNA 输出后，结果中会用 U 代替 T。输入中的 U 会被视为等同于 T。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const revcomp_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.revcomp_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("revcomp_faq_a2", locale)
	if (locale === "en") return en_revcomp_faq_a2(inputs)
	if (locale === "es") return es_revcomp_faq_a2(inputs)
	if (locale === "de") return de_revcomp_faq_a2(inputs)
	if (locale === "nl") return nl_revcomp_faq_a2(inputs)
	if (locale === "fr") return fr_revcomp_faq_a2(inputs)
	if (locale === "it") return it_revcomp_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_revcomp_faq_a2(inputs)
	if (locale === "pt") return pt_revcomp_faq_a2(inputs)
	if (locale === "ja") return ja_revcomp_faq_a2(inputs)
	return zh_revcomp_faq_a2(inputs)
};